<template>
  <component
    :is="as"
    class="nav-item"
    :class="{ collapsed, 'exact-match': exactMatch, admin }"
    v-bind="$attrs"
    v-on="$listeners"
    :title="collapsed ? text : ''"
  >
    <icon :name="icon" />

    <div class="text-wrapper">
      <div class="text secondary-font">{{ text }}</div>
      <div v-if="subtext" class="subtext">{{ subtext }}</div>
    </div>

    <span class="slot-wrapper">
      <slot />
    </span>
  </component>
</template>

<script>
import Icon from './Icon';

export default {
  components: {
    Icon,
  },

  props: {
    as: {
      type: String,
      default: 'div',
    },
    icon: String,
    text: String,
    subtext: String,
    collapsed: Boolean,
    exactMatch: Boolean,
    admin: Boolean,
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/global.scss';

.nav-item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: $gp * .5;
  color: var(--theme-color);
  text-decoration: none !important;
  border-radius: $border-radius;
  margin-bottom: $gp * .25;
  background-color: transparent;
  border: none;
  text-align: left;
  cursor: pointer;
  line-height: 24px;

  &.admin {
    color: $color-green-1;
  }

  .icon {
    margin-right: $gp * .75;
    color: $color-green-1;
  }

  &.collapsed {
    justify-content: center;

    .icon {
      margin-right: 0;
    }
  }
  .text-wrapper {
    flex: 1;
  }

  .text {
    font-weight: bold;
    font-size: 16px;
  }

  .subtext {
    font-size: 14px;
  }

  .slot-wrapper {
    line-height: 1;
  }

  &:hover {
    background-color: var(--theme-highlight);
  }

  &:not(.exact-match) {
    &.nuxt-link-active,
    &.router-link-active {
      background-color: var(--theme-active);
    }
  }

  &.exact-match {
    &.nuxt-link-exact-active,
    &.router-link-exact-active {
      background-color: var(--theme-active);
    }
  }

  @media($medium-up) {
    &.collapsed {
      *:not(.icon) {
        display: none;
      }
    }
  }
}
</style>
